import React from "react";
import { cn } from "@/lib/utils";

export const NeoCard = ({ children, className, ...rest }) => (
  <div
    className={cn(
      "relative bg-white border-[3px] border-black rounded-xl p-5 sm:p-8 shadow-[6px_6px_0_0_#000] sm:shadow-[8px_8px_0_0_#000] transition-shadow",
      className
    )}
    {...rest}
  >
    {children}
  </div>
);

export const NeoBadge = ({ children, variant = "default", className, ...rest }) => {
  const variants = {
    default: "bg-black text-white",
    yellow: "bg-[#ffd60a] text-black",
    pink: "bg-[#ff5e78] text-black",
    lime: "bg-[#c4f04a] text-black",
    cyan: "bg-[#5ce1ff] text-black",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider border-[2px] border-black rounded-md",
        variants[variant],
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
};
